import theme from "@/styles/theme";
import styled from "styled-components";

interface ISize {
  width?:string,
  height?:string,
}

const MobileVisibilityContainer = styled.div<ISize>`
  @media(min-width:${theme.breakpoint.small}) {
    display:none;
  };
  width:${({width}) => width ? width : '100%'};
  height:${({height}) => height ? height : '100%'};
`;

const WebVisibilityContainer = styled.div<ISize>`
  @media(max-width:${theme.breakpoint.small}) {
    display:none;
  };
  width:${({width}) => width ? width : '100%'};
  height:${({height}) => height ? height : '100%'};
`;

const responsive = {
  MobileVisibilityContainer,
  WebVisibilityContainer
}

export default responsive;